// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4e06dc6b","667":"9672b225","977":"36357139"}[chunkId] + ".chunk.js";
};